export const qaIntegrationMessage = {
  evaluationDate: 'Ngày đánh giá',
  ticketCreatedDate: 'Ngày yêu cầu',

  qaIntegrationInformationTitle: 'Thông tin đánh giá',
  evaluator: 'Người đánh giá',
  fileRecord: 'File ghi âm',
  videoRecord: 'Video ghi âm',
  completionDate: 'Ngày xác nhận',
  playFileRecord: 'Phát file ghi âm',
  playVideoRecord: 'Mở video ghi hình',

  ticketInformation: 'Thông tin phiếu'
};
